export const clickTracking = {
  category: 'Click',
  label: 'playmakers',
  name: 'playmakers',
};
